import React from 'react';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useMediaQuery, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { StyledAccordion, StyledAccordionSummary } from './style';

const FaqContainer = ({ faqs, fullSize = false }) => {
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const intl = useIntl();
  const i18n = translations.TicketsV2(intl).Common;

  return (
    <div
      style={{
        marginTop: '40px',
        width: isLgDown || fullSize ? '100%' : '64%',
        ...(!isLgDown &&
          !fullSize && {
            paddingRight: '70px',
          }),
      }}
    >
      <Typography
        variant="l"
        component={'h2'}
        sx={{ mb: '15px' }}
        marginBottom={'15px !important'}
      >
        {i18n.faqTitle}
      </Typography>
      {faqs.faqList.map((faq, idx) => (
        <StyledAccordion
          sx={{
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
          }}
          key={idx}
          showBefore={idx !== 0}
        >
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon fontSize="large" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ padding: 0 }}
          >
            <Typography
              variant="body1-bold"
              fontFamily={'Suisse-Intl'}
              color={'#333333'}
              component={'p'}
            >
              {faq.title}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Typography
              variant="body2"
              fontFamily={'Suisse-Intl'}
              color={'#333333'}
              component={'h2'}
            >
              {faq.body}
            </Typography>
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </div>
  );
};
export { FaqContainer };
